import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  Grid,
  TextField,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  Button,
  IconButton,
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteIcon from "@material-ui/icons/Delete";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { dateLocale } from "@icarius-localization/strings";
import { getLocalizedString } from "@icarius-localization/strings";
import { createDateFromDDMMYYYY } from "@icarius-utils/date";
import NoteFormLabelMenu from '../inputs/NoteFormLabelMenu';
import NoteLabel from '../inputs/noteLabel';
import CustomNumberFormat from '@icarius-common/dynamicInputs/customNumberFormat';

const gridStyle = { height: 75, padding: "0px 10px" };

const TabGeneral = (props) => {
  const {
    editMode,
    currentNode,
    handleChangeField,
    positionClassifications,
    competencyGroupList,
    evaluationGroupList,
    orgChart,
  } = props;

  const handleRemoveLabel = (labels, id) => {
    const newLabels = labels.filter(item => item !== id);
    handleChangeField("Etiquetas", newLabels);
  };

  return (
    <>
      <Grid container item xs={12}>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <TextField
            disabled={!editMode}
            fullWidth
            required
            margin={"none"}
            value={`${currentNode["ID del cargo"]}`}
            onChange={m => handleChangeField("ID del cargo", m.target.value)}
            label={getLocalizedString("jobId")}
            style={{ marginTop: 10 }}
            inputProps={{ maxLength: 100 }}
            type={"text"}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <TextField
            disabled={!editMode}
            fullWidth
            required
            margin={"none"}
            value={`${currentNode["Nombre del cargo"]}`}
            onChange={m => handleChangeField("Nombre del cargo", m.target.value)}
            label={getLocalizedString("positionEditorPositionName")}
            style={{ marginTop: 10 }}
            inputProps={{ maxLength: 100 }}
            type={"text"}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <FormControl style={{ width: "100%", marginTop: 10 }}>
            <InputLabel shrink id="branchLabel">{getLocalizedString("evaluationGroup")}</InputLabel>
            <Select
              disabled={!editMode}
              displayEmpty
              labelId="branchLabel"
              fullWidth
              onChange={(e) => handleChangeField("Grupo de evaluación", e.target.value)}
              margin={"none"}
              value={currentNode["Grupo de evaluación"] || ""}
            >
              {
                evaluationGroupList.map(item => (
                  <MenuItem
                    className={"whiteText"}
                    key={item.key}
                    value={item.key}
                  >
                    {item.value}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <TextField
            disabled={!editMode}
            fullWidth
            required
            margin={"none"}
            label={getLocalizedString("positionEditorPositionQuantity")}
            value={`${currentNode["Cantidad de puestos"]}`}
            onChange={m => handleChangeField("Cantidad de puestos", m.target.value)}
            style={{ marginTop: 10 }}
            InputProps={{ inputComponent: CustomNumberFormat }}
            inputProps={{ maxLength: 4, decimals: 0, min: "1", step: "1" }}
            type={"text"}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <FormControl style={{ width: "100%", marginTop: 10 }}>
            <InputLabel id="branchLabel" required>{getLocalizedString("positionEditorResponsabilityDegree")}</InputLabel>
            <Select
              disabled={!editMode}
              labelId="branchLabel"
              fullWidth
              onChange={(e) => handleChangeField("Grado de responsabilidad", e.target.value)}
              margin={"none"}
              value={currentNode["Grado de responsabilidad"] || "-"}
            >
              {
                [...Array(13).keys()].map(item => (
                  <MenuItem
                    className={"whiteText"}
                    key={item}
                    value={!item ? "-" : String(item).padStart(2, '0')}>
                    {!item ? "-" : String(item).padStart(2, '0')}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <FormControl style={{ width: "100%", marginTop: 10 }}>
            <InputLabel shrink id="branchLabel">{getLocalizedString("specificCompetencyGroup")}</InputLabel>
            <Select
              disabled={!editMode}
              displayEmpty
              labelId="branchLabel"
              fullWidth
              onChange={(e) => handleChangeField("Grupo de competencias específicas", e.target.value)}
              margin={"none"}
              value={currentNode["Grupo de competencias específicas"] || ""}
            >
              {
                competencyGroupList.map(item => (
                  <MenuItem
                    className={"whiteText"}
                    key={item.key}
                    value={item.key}
                  >
                    {item.value}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <TextField
            disabled
            fullWidth
            required
            margin={"none"}
            value={`${currentNode["Puestos ocupados"]}`}
            onChange={m => handleChangeField("Puestos ocupados", m.target.value)}
            label={getLocalizedString("positionEditorOccupiedPositions")}
            style={{ marginTop: 10 }}
            inputProps={{ min: "0", step: "1", maxLength: 4, decimals: 0 }}
            InputProps={{ inputComponent: CustomNumberFormat }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <TextField
            fullWidth
            disabled={!editMode}
            margin={"none"}
            style={{ marginTop: 10 }}
            value={currentNode["Potencial motivador del cargo"] || "1"}
            onChange={m => handleChangeField("Potencial motivador del cargo", m.target.value)}
            label={getLocalizedString("motivatorPotential1To125")}
            InputProps={{ inputComponent: CustomNumberFormat }}
            inputProps={{ min: "1", step: "0.1", decimals: 0 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <TextField
            disabled
            fullWidth
            margin={"none"}
            value={orgChart && currentNode && currentNode["ID del cargo superior"] ? (orgChart.find(n => n["ID"] === currentNode["ID del cargo superior"]) || {})["Nombre del cargo"] || "-" : "-"}
            label={getLocalizedString("superiorPosition")}
            style={{ marginTop: 10 }}
            type={"text"}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <TextField
            disabled
            fullWidth
            required
            margin={"none"}
            value={`${currentNode["Puestos libres"]}`}
            onChange={m => handleChangeField("Puestos libres", m.target.value)}
            label={getLocalizedString("positionEditorFreePositions")}
            style={{ marginTop: 10 }}
            inputProps={{ min: "0", step: "1", maxLength: 4, decimals: 0 }}
            InputProps={{ inputComponent: CustomNumberFormat }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
            <DatePicker
              disabled={!editMode}
              fullWidth
              required
              label={getLocalizedString("potentialUpdateDate")}
              cancelLabel={getLocalizedString("cancel")}
              okLabel={getLocalizedString("ok")}
              invalidDateMessage=''
              format="dd/MM/yyyy"
              margin="normal"
              value={typeof currentNode["Fecha actualización del potencial"] === "string" ? createDateFromDDMMYYYY(currentNode["Fecha actualización del potencial"]) : currentNode["Fecha actualización del potencial"]}
              onChange={m => handleChangeField("Fecha actualización del potencial", m)}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        {
          currentNode && currentNode["pid"] &&
          <Grid container item alignItems="center" xs={12} style={gridStyle} >
            <FormControlLabel
              control={
                <Switch
                  checked={currentNode.hasOwnProperty("tags") ? currentNode.tags.includes("assistant") : false}
                  onChange={() => handleChangeField("Asistente", !(currentNode.hasOwnProperty("tags") ? currentNode.tags.includes("assistant") : false))}
                  value={currentNode.hasOwnProperty("tags") ? currentNode.tags.includes("assistant") : false}
                  color="primary"
                />
              }
              label={getLocalizedString("positionEditorAssistant")}
              labelPlacement="start"
              style={{ margin: 5, marginLeft: -30 }}
              disabled={!editMode}
              required
            />
          </Grid>
        }
      </Grid>
      {
        currentNode && currentNode["Etiquetas"] &&
        <div className="flex flex-wrap w-full p-4" style={{ paddingBottom: 8 }}>
          {
            currentNode["Etiquetas"].map((item, i) => (
              <NoteLabel
                actualLabels={currentNode["Etiquetas"]}
                labels={positionClassifications}
                labelCode={item}
                key={i}
                className="mt-4 mr-4"
                onDelete={editMode ? handleRemoveLabel : null}
              />
            ))
          }
        </div>
      }
      <div style={{ display: 'flex', gap: 10, paddingLeft: 16, paddingRight: 16, paddingBottom: 16, alignItems: 'center' }}>
        {
          editMode && currentNode && currentNode["Etiquetas"] &&
          <NoteFormLabelMenu labels={positionClassifications} values={currentNode["Etiquetas"]} onChange={handleChangeField} />
        }
        {
          editMode && currentNode &&
          <React.Fragment>
            <input
              accept=".pdf"
              style={{ display: 'none' }}
              id="raised-button-file"
              type="file"
              onChange={(e) => {
                if (e.target.files && e.target.files.length > 0) {
                  const file = e.target.files[0];
                  const reader = new FileReader();
                  reader.onload = (event) => {
                    handleChangeField("Adjunto", event.target.result);
                  };
                  reader.readAsDataURL(file);
                  e.target.value = null;
                }
              }}
            />
            <label htmlFor="raised-button-file" style={{ marginBottom: 0 }}>
              <Button
                variant="outlined"
                component="span"
                className="whiteText"
              >
                <AttachFileIcon style={{ marginRight: 5, fontSize: 18 }} />
                {getLocalizedString("attachment")}
              </Button>
            </label>
          </React.Fragment>
        }
        {
          currentNode && currentNode["Adjunto"] &&
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              className="whiteText"
              variant="text"
              style={{ textDecoration: 'underline' }}
              onClick={() => {
                const file = currentNode["Adjunto"];
                if (file instanceof File) {
                  const fileURL = URL.createObjectURL(file);
                  window.open(fileURL, '_blank');
                } else if (typeof file === 'string') {
                  if (file.startsWith('data:')) {
                    const arr = file.split(',');
                    const mime = arr[0].match(/:(.*?);/)[1];
                    const bstr = atob(arr[1]);
                    let n = bstr.length;
                    const u8arr = new Uint8Array(n);
                    while (n--) {
                      u8arr[n] = bstr.charCodeAt(n);
                    }
                    const blob = new Blob([u8arr], { type: mime });
                    const fileURL = URL.createObjectURL(blob);
                    window.open(fileURL, '_blank');
                  } else {
                    window.open(file, '_blank');
                  }
                }
              }}
            >
              Ver Adjunto
            </Button>
            {editMode && (
              <IconButton size="small" style={{ color: '#ff4d4f', marginLeft: 8 }} onClick={() => handleChangeField("Adjunto", null)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </div>
        }
      </div>
    </>
  );
};

export default TabGeneral;
